import { useSeo } from "@/lib/useSeo";
import { useSettings } from "@/lib/SettingsContext";
import { PageHeader, Section, Prose } from "@/components/Editorial";

function LegalShell({ title, description, path, children }) {
  useSeo({ title, description, path });
  return (
    <div>
      <PageHeader eyebrow="Informations légales" title={title} />
      <Section><Prose>{children}</Prose></Section>
    </div>
  );
}

export function MentionsLegales() {
  const s = useSettings();
  return (
    <LegalShell title="Mentions légales" description="Mentions légales du site officiel de Dorothée Lancelot." path="/mentions-legales">
      <h3 className="serif text-2xl text-[#F3E9D2]">Éditeur du site</h3>
      <p>Nom public / nom d'activité : <b>Dorothée Lancelot</b>.<br />
        SIRET professionnel : <b data-testid="legal-siret">{s?.siret_pro || "[À renseigner]"}</b>.</p>
      <p className="text-sm text-[#F3E9D2]/55 italic">Ce SIRET correspond à l'activité professionnelle de Dorothée Lancelot et ne doit pas être confondu avec celui de l'association AAESAD.</p>
      <h3 className="serif text-2xl text-[#F3E9D2]">Responsable de la publication</h3>
      <p>Dorothée Lancelot.</p>
      <h3 className="serif text-2xl text-[#F3E9D2]">Hébergement</h3>
      <p>Les informations relatives à l'hébergeur seront précisées ici.</p>
      <h3 className="serif text-2xl text-[#F3E9D2]">Propriété intellectuelle</h3>
      <p>L'ensemble des contenus (textes, images, couvertures, visuels, vidéos) est protégé. Toute reproduction sans autorisation est interdite.</p>
      <h3 className="serif text-2xl text-[#F3E9D2]">Association AAESAD</h3>
      <p>SIRET AAESAD : <b>{s?.siret_aaesad || "814 719 829 000 24"}</b>. Ce numéro concerne uniquement l'association Aide et Soutien au Deuil.</p>
    </LegalShell>
  );
}

export function Confidentialite() {
  return (
    <LegalShell title="Politique de confidentialité" description="Politique de confidentialité et gestion des données personnelles du site de Dorothée Lancelot." path="/confidentialite">
      <p>Ce site propose un espace de demande qualifiée (consultation, conférence, presse, partenariat). Les informations que vous y saisissez (nom, e-mail, téléphone facultatif, message) sont utilisées <strong>uniquement</strong> pour traiter votre demande et ne sont jamais cédées à un tiers.</p>
      <p><strong>Mesure d'audience :</strong> le site utilise une mesure interne, respectueuse de la vie privée, qui comptabilise des actions anonymes (pages vues, clics sur les boutons principaux). Aucun cookie publicitaire, aucun traceur tiers, aucune adresse IP ni donnée nominative ne sont conservés. L'identifiant de session est temporaire (effacé à la fermeture de l'onglet).</p>
      <p>Conformément au RGPD, toute personne dispose d'un droit d'accès, de rectification et de suppression de ses données, en écrivant à l'adresse de contact indiquée sur le site.</p>
    </LegalShell>
  );
}

export function Cookies() {
  return (
    <LegalShell title="Politique cookies" description="Politique de gestion des cookies du site de Dorothée Lancelot." path="/cookies">
      <p>Le site utilise uniquement les cookies nécessaires à son bon fonctionnement.</p>
      <p>Aucun cookie publicitaire n'est déposé sans consentement. Si des outils de mesure d'audience sont ajoutés, cette politique sera actualisée.</p>
    </LegalShell>
  );
}

export function CGV() {
  const s = useSettings();
  return (
    <LegalShell title="Conditions Générales de Vente" description="Conditions générales de vente applicables en cas de vente directe sur le site de Dorothée Lancelot." path="/cgv">
      <p>Les présentes conditions s'appliqueront en cas d'activation d'une vente directe sur le site.</p>
      <p>Vendeur : Dorothée Lancelot — SIRET {s?.siret_pro || "[À renseigner]"}.</p>
      <p>Les modalités de commande, de paiement, de livraison et de rétractation seront précisées lors de la mise en place de la boutique en vente directe.</p>
    </LegalShell>
  );
}
